import { useState } from 'react';
import { isNewAppShell } from '../utils/newAppShell';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

// Flips once the first hydration has committed. After that nothing is server-rendered any more, so a
// component mounted by a client navigation can read the <html> flag right away instead of rendering
// «not the app» first (which left the app bar out and shifted the page when it appeared).
let hydrated = false;

/** True inside the new Android app (version_code ≥ 9100); see utils/newAppShell. */
export const useIsNewAppShell = () => {
  // Server and hydration render false; the layout effect flips it before the browser paints.
  const [state, setState] = useState(() => hydrated && isNewAppShell());

  useIsomorphicLayoutEffect(() => {
    hydrated = true;
    setState(isNewAppShell());
  }, []);

  return state;
};

export default useIsNewAppShell;
